import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import infoIcon from "../assets/images/infobtnblue.svg";
import annualsummary from "../assets/images/My_machine.svg";
import DemoLogo from "../assets/images/quantummain.svg";
import axios from "axios";
import { toast } from "react-toastify";
import star from "../assets/images/stars.svg";
import MachineNameUpdateModal from "../Modals/MachineNameUpdateModal";
import { apiResponse } from "../services/APIResponse";
import { API_URL } from "../services/APIRoute";
import { apiCall } from "../services/AxiosService";
import { commonservices, CountCharacter } from "../services/CommonServices";
import BreadcrumbsNav from "./common-component/BreadcrumbsNav";
import CKeditorComponent from "./common-component/CKeditorComponent";
import DropFileInput from "./common-component/DropFileInput";
import Loader, { LoaderType } from "./common-component/Loader";
import { useDispatch } from "react-redux";
import {
  GetMachineDetailByPrimaryKey,
  MachineVersionUpdate,
} from "../services/ReduxTookit/Slice/MachineRedux";
import SubmitLoading from "./common-component/Loaders/SubmitLoading";
import MainpageLoader from "./common-component/Loaders/MainpageLoader";

function UpdateMachineVersion() {
  let param = useParams();

  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [Loading, setLoading] = useState(false);
  const [FileRemoveButton, setFileRemoveButton] = useState(false);
  const [MachineNameUpdateModalShow, setMachineNameUpdateModalShow] =
    useState(false);
  const [MachineDetailLoader, setMachineDetailLoader] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [MachineDetails, setMachineDetails] = useState();

  const BreadcrumbSingle = [
    {
      name: "My Machine",
      link: "/machine",
      active: false,
    },
    {
      name: MachineDetails?.dataList1?.[0]?.machinename,
        link: `/marketplace/marketplace-detail/${param?.id}/my machine`,
      active: false,
    },
    {
      name: "Update Version",
      active: true,
    },
  ];
  const [input, setInput] = useState({
      machineid: commonservices.bodyDecryption(param?.id),
    machinename: "",
    versionnumber: "",
    zipfilepath: "",
    bugresolved: "",
    errors: {
        machineid: commonservices.bodyDecryption(param?.id),
      versionnumber: "",
      zipfilepath: "",
      bugresolved: "",
      ValidationRules: [
        {
          FieldName: "zipfilepath",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "bugresolved",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });
  const onFileChange = async (files) => {
    if (files) {
      let data = new FormData();
      data.append("jsonfile", files);
      data.append("callfrom", "update");
      const options = {
        headers: commonservices.getHeadersFromData(),
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          let percent = Math.floor((loaded * 100) / total);
          if (percent < 100) {
            setUploadPercentage(percent);
          }
        },
      };
      try {
        const res = await axios.post(
          API_URL.BASEURL + API_URL.MACHINEVALIDATEZIPFILE,
          data,
          options
        );
        if (res?.data?.status_code === 1) {
          setUploadPercentage(100);
          setTimeout(() => {
            setUploadPercentage(0);
          }, 1000);
          if (res?.data && res?.data?.data?.version) {
            if (
              param?.versionnumber === res?.data?.data?.version &&
              res?.data?.data?.name ===
              MachineDetails?.dataList1?.[0]?.machinename
            ) {
              if (res?.data?.data?.name?.length < 67) {
                setInput({
                  ...input,
                  versionnumber: res?.data?.data?.version,
                  zipfilepath: res?.data?.data?.filepath,
                  machinename: res?.data?.data?.name,
                });
                toast.success(res?.data?.message);
              } else {
                toast.error(
                  "Invalid Machine name in  ZIP of Project.json file. Ensure the machine name is no more than 67 characters."
                );
              }

              // if (
              //   MachineDetails?.dataList1[0]?.machinename !==
              //   res?.data?.data?.name
              // ) {
              //   setMachineNameUpdateModalShow(true);
              // }
            } else {
              toast.error(
                "Machine name or Version numbers do not match. Please check and try again."
              );
            }
          }
        } else {
          toast.error(res?.data?.message);
          setInput({
            ...input,
            versionnumber: "",
            zipfilepath: "",
          });
        }
      } catch (error) { }
    } else {
      setInput({
        ...input,
        machinename: "",
        versionnumber: "",
      });
    }
  };
  const handleCKEditor = (content, tag) => {
    if (content?.length < 1950) {
      setInput({
        ...input,
        [tag]: content,
      });
    } else {
      toast.error("Exceed maximum content");
    }
  };
  async function getMachineDetails() {
    setMachineDetailLoader(true);
    let body = {
        id: commonservices.bodyDecryption(param?.id),
    };

    dispatch(GetMachineDetailByPrimaryKey(body)).then((res) => {
      if (res?.payload?.isValidate) {
        setMachineDetails(res?.payload?.data?.data);
        setMachineDetailLoader(false);
      } else {
        setMachineDetailLoader(false);
      }
    });

    // ----------------- Before Redux
    // let resData = await apiCall(
    //   {
    //     method: "POST",
    //     url: API_URL.BASEURL + API_URL.MACHINEGETBYPRIMARYKEYINDETAILS,
    //     body: body,
    //   },
    //   true
    // );
    // let response = apiResponse(false, resData, setMachineDetailLoader);
    // if (response?.isValidate) {
    //   setMachineDetails(response?.data?.data);
    //   // setMainImage(response?.data?.data?.dataList5[0]?.bannerurl);
    // }
    // if (!response?.isValidate) {
    // }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    let obj = commonservices.fnCheckValidationOfObject(input);
    setInput({
      ...obj.obj,
    });
    if (obj.isValid) {
      setLoading(true);
      let body = {
        machineid: parseInt(input?.machineid),
        versionnumber: input.versionnumber,
        zipfilepath: input.zipfilepath,
        bugresolved: input.bugresolved,
      };

      dispatch(MachineVersionUpdate(body)).then((res) => {
        if (res?.payload?.isValidate) {
          setLoading(false);
            navigate(`/marketplace/marketplace-detail/${param?.id}/my machine`);
        } else {
          setLoading(false);
        }
      });
      // ----------------- Before Redux
      // let resData = await apiCall(
      //   {
      //     method: "PUT",
      // url: API_URL.BASEURL + API_URL.MACHINE_VERSION_UPDATE,
      //     body: body,
      //   },
      //   true
      // );
      // let response = apiResponse(true, resData, setLoading);
      // if (response?.isValidate) {
      //   navigate(`/marketplace/marketplace-detail/${param?.id}/my machine`);
      // }
      // if (!response?.isValidate) {
      // }
    }
  };
  useEffect(() => {
    getMachineDetails();
  }, []);

  return (
    <div className="dashboard-main market-place-page-main market-place-detail-page-main">
      {Loading && <MainpageLoader />}
      <div className="all-page-top">
        <Container>
          <div className="top-section-all d-block">
            <div className="top-section-left">
              <BreadcrumbsNav pageNav={BreadcrumbSingle} />
              {MachineDetailLoader ? (
                <Loader type={LoaderType.MarketHeader} count={1} />
              ) : (
                <div className="d-flex align-items-center justify-content-between w-100 mb40">
                  <div className="top-left-sect-detail">
                    <div
                      className={`top-left-sect-detail-img single-market-place-img ${commonservices.MachineStatus(
                        MachineDetails?.dataList1[0]?.status
                      )}`}
                    >
                      <img
                        className="rounded-0"
                        src={
                          MachineDetails?.dataList1[0]?.machinelogo !== "" &&
                            MachineDetails?.dataList1[0]?.machinelogo !== null
                            ? MachineDetails?.dataList1[0]?.machinelogo
                            : DemoLogo
                        }
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = DemoLogo;
                        }}
                        alt="machineicon"
                      />
                    </div>
                    <div className="top-left-sect-detail-content">
                      <div className="title-rating">
                        <h5>{MachineDetails?.dataList1[0]?.machinename}</h5>
                        <div className="version-name cursor-pointer">
                          {param?.versionnumber}
                        </div>
                        <div className="title-rating mt-2     justify-content-center">
                          {MachineDetails?.dataList2[0]?.averagerating > 0 && (
                            <div className="rating-main">
                              <img src={star} alt="star" />
                              <p>
                                {MachineDetails?.dataList2[0]?.averagerating?.toFixed(
                                  1
                                )}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: MachineDetails?.dataList2[0]?.shortdescription
                            ? commonservices.truncateText(
                              commonservices.stripHTML(
                                MachineDetails?.dataList2[0]?.shortdescription
                              ),
                              CountCharacter.MarketPlaceShortDetail
                            )
                            : "",
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Container>
      </div>
      <div className="main-page-content profilecomplate-common ">
        <Container>
          <div className="all-marketplace-wrapper">
            <h5>Update Version</h5>
            <hr />
            <Form
              onSubmit={(e) => {
                handleSubmit(e);
              }}
            >
              <Row>
                <Col md={6}>
                  <Form.Group className="form-group mb-3">
                    <Form.Label className="login-label">
                      Select Version
                      <span className="ms-1 red-color-text">*</span>
                    </Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="text"
                        disabled
                        maxLength={67}
                        placeholder="Select Version"
                        className="common-input"
                        value={param?.versionnumber}
                      />
                    </div>
                  </Form.Group>
                  <Form.Group className="form-group">
                    <DropFileInput
                      removefile={FileRemoveButton}
                      uploadPercentage={uploadPercentage}
                      onFileChange={(files) => onFileChange(files)}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="formProfilePic">
                    <Form.Label className="common-label">
                      Resolved Bugs & Issues
                      <span className="ms-1 red-color-text">*</span>
                    </Form.Label>
                    <div className="position-relative">
                      <div
                        className={`${input.errors.bugresolved && "error-border-line"
                          }`}
                      >
                        <div className=" datamachineflow">
                          <CKeditorComponent
                            onChange={handleCKEditor}
                            tag="bugresolved"
                            value={input.bugresolved}
                          />
                        </div>
                      </div>
                      {input.errors.bugresolved && (
                        <p className="error-line">
                          <span className="error-message-icon">
                            <img
                              src={infoIcon}
                              alt="infoIcon"
                              title={input.errors.bugresolved}
                            />
                          </span>
                        </p>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <hr />
              {input?.versionnumber !== "" && (
                <div className="text-end my-3">
                  <button
                    className="grey-btn w-auto me-2"
                    type="reset"
                    onClick={(e) => {
                      e.preventDefault();
                      setFileRemoveButton(true);
                      setInput({
                        ...input,
                        versionnumber: "",
                        zipfilepath: "",
                        bugresolved: "",
                        machinename: "",
                      });
                      // navigate(`/marketplace/marketplace-detail/${param?.id}/my machine`)
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    disabled={Loading}
                    className="blue-btn w-auto"
                    type="submit"
                  >
                    {Loading ? (
                      // <>
                      //   <span>Loading</span>
                      //   <Spinner
                      //     className="ms-1"
                      //     animation="border"
                      //     role="status"
                      //     size="sm"
                      //   >
                      //     <span className="visually-hidden">Loading...</span>
                      //   </Spinner>
                      // </>
                      <SubmitLoading />
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              )}
            </Form>
          </div>
        </Container>
      </div>
      {MachineNameUpdateModalShow && (
        <MachineNameUpdateModal
          detail={MachineDetails}
          zipdetail={input}
          show={MachineNameUpdateModalShow}
          confirmkey={() => setMachineNameUpdateModalShow(false)}
          onHide={() => {
            setMachineNameUpdateModalShow(false);
            setInput({
              ...input,
              versionnumber: "",
              zipfilepath: "",
              bugresolved: "",
              machinename: "",
            });
          }}
        />
      )}
    </div>
  );
}

export default UpdateMachineVersion;
